
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class H5ActionBtns extends Vue {

    // props
    @Prop() public isCollected!: boolean
    @Prop({default() { return true}}) public showDownload!: boolean
    @Prop({default() { return false}}) public showTheSame!: boolean
    @Prop({default() { return false}}) public show1V1!: boolean
    @Prop({default() { return true}}) public showShare!: boolean
    @Prop({default() { return true}}) public showCollect!: boolean

    //emit
    public collect() {
        this.$emit('collect', this.isCollected)
    }
    public download() {
        this.$emit('download')
    }
    public share() {
        this.$emit('share')
    }
    public theSame() {
        this.$emit('theSame')
    }
    // methods
    public go1V1() {
        const uni = (window as any).uni
        uni.navigateTo({
            url: `/pages/common/add-teacher/add-teacher`
        })
    }
}